// extracted by mini-css-extract-plugin
export default {"container":"ProfileIconLoader_container__+Le4A"};